<div class="robot-service-detail-container" [testId]="'robot-service-detail-container'">
  <nz-spin [nzSpinning]="loading" [testId]="'loading-spinner'">
    <form nz-form [formGroup]="robotForm" class="form-container" nzLayout="horizontal" [testId]="'robot-form'">
      <nz-card [testId]="'robot-form-card'">
        <div class="card-header" [testId]="'card-header'">
          <h3 [testId]="'form-title'">{{ robotId ? ('robot-service.edit-title' | i18n) : ('robot-service.add-title' | i18n) }}</h3>
        </div>
        <nz-divider [testId]="'form-divider'" />

        <div nz-row [nzGutter]="24" [testId]="'form-row'">
          <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'name-col'">
            <nz-form-item [testId]="'name-form-item'">
              <nz-form-label [nzSpan]="8" nzRequired nzFor="name" [testId]="'name-label'">{{
                'robot-service.form.name' | i18n
              }}</nz-form-label>
              <nz-form-control [nzSpan]="16" [nzErrorTip]="'robot-service.form.name-required' | i18n" [testId]="'name-control'">
                <input
                  nz-input
                  formControlName="name"
                  id="name"
                  [placeholder]="'robot-service.form.name-placeholder' | i18n"
                  [testId]="'name-input'"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'type-col'">
            <nz-form-item [testId]="'type-form-item'">
              <nz-form-label [nzSpan]="8" nzRequired nzFor="type" [testId]="'type-label'">{{
                'robot-service.form.type' | i18n
              }}</nz-form-label>
              <nz-form-control [nzSpan]="16" [nzErrorTip]="'robot-service.form.type-required' | i18n" [testId]="'type-control'">
                <nz-select
                  formControlName="type"
                  id="type"
                  [nzPlaceHolder]="'robot-service.form.type-placeholder' | i18n"
                  [testId]="'type-select'"
                >
                  <nz-option
                    *ngFor="let option of typeOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'type-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'language-col'">
            <nz-form-item [testId]="'language-form-item'">
              <nz-form-label [nzSpan]="8" nzRequired nzFor="language" [testId]="'language-label'">{{
                'robot-service.form.language' | i18n
              }}</nz-form-label>
              <nz-form-control [nzSpan]="16" [nzErrorTip]="'robot-service.form.language-required' | i18n" [testId]="'language-control'">
                <nz-select
                  formControlName="language"
                  id="language"
                  [nzPlaceHolder]="'robot-service.form.language-placeholder' | i18n"
                  [testId]="'language-select'"
                >
                  <nz-option
                    *ngFor="let option of languageOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'language-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'identity-type-col'">
            <nz-form-item [testId]="'identity-type-form-item'">
              <nz-form-label [nzSpan]="8" nzRequired nzFor="identityType" [testId]="'identity-type-label'">{{
                'robot-service.form.identity-type' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="16"
                [nzErrorTip]="'robot-service.form.identity-type-required' | i18n"
                [testId]="'identity-type-control'"
              >
                <nz-select
                  formControlName="identityType"
                  id="identityType"
                  [nzPlaceHolder]="'robot-service.form.identity-type-placeholder' | i18n"
                  [testId]="'identity-type-select'"
                >
                  <nz-option
                    *ngFor="let option of identityTypeOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'identity-type-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'is-default-col'">
            <nz-form-item [testId]="'is-default-form-item'">
              <nz-form-label [nzSpan]="8" nzRequired nzFor="isDefault" [testId]="'is-default-label'">{{
                'robot-service.form.is-default' | i18n
              }}</nz-form-label>
              <nz-form-control [nzSpan]="16" [nzErrorTip]="'robot-service.form.is-default-required' | i18n" [testId]="'is-default-control'">
                <nz-select
                  formControlName="isDefault"
                  id="isDefault"
                  [nzPlaceHolder]="'robot-service.form.is-default-placeholder' | i18n"
                  [testId]="'is-default-select'"
                >
                  <nz-option
                    *ngFor="let option of defaultOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'is-default-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'url-col'">
            <nz-form-item [testId]="'url-form-item'">
              <nz-form-label [nzSpan]="4" nzRequired nzFor="url" [testId]="'url-label'">{{
                'robot-service.form.service-url' | i18n
              }}</nz-form-label>
              <nz-form-control [nzSpan]="20" [nzErrorTip]="'robot-service.form.service-url-required' | i18n" [testId]="'url-control'">
                <input
                  nz-input
                  formControlName="url"
                  id="url"
                  [placeholder]="'robot-service.form.service-url-placeholder' | i18n"
                  [testId]="'url-input'"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" [testId]="'description-col'">
            <nz-form-item [testId]="'description-form-item'">
              <nz-form-label [nzSpan]="4" nzRequired nzFor="description" [testId]="'description-label'">{{
                'robot-service.form.description' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSpan]="20"
                [nzErrorTip]="'robot-service.form.description-required' | i18n"
                [testId]="'description-control'"
              >
                <textarea
                  nz-input
                  formControlName="description"
                  id="description"
                  [placeholder]="'robot-service.form.description-placeholder' | i18n"
                  [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                  [testId]="'description-textarea'"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-card>
    </form>
  </nz-spin>

  <div class="footer-actions" [testId]="'footer-actions'">
    <button nz-button (click)="cancel()" [testId]="'cancel-button'">{{ 'common.cancel' | i18n }}</button>
    <button nz-button nzType="primary" (click)="saveRobot()" [nzLoading]="submitting" [testId]="'save-button'">{{
      'common.save' | i18n
    }}</button>
  </div>
</div>
